import { iUIschemaV1 } from '../interfaces/iUIschemaV1'
import { scopeAddRepeat } from '../../utils/scopeModifs'
import { modifRules } from '../rules/modifRules'

export const convertUiSchemaArray = (
  uiSchema: iUIschemaV1,
  arrayScope: string,
  index: number,
  parentScope = '',
): iUIschemaV1 => {
  const scope = uiSchema.scope ? scopeAddRepeat(uiSchema.scope, arrayScope, index) : undefined
  const scopeRef = uiSchema.scopeRef ? scopeAddRepeat(uiSchema.scopeRef, arrayScope, index) : undefined
  const actParentScope = parentScope ? parentScope : scopeAddRepeat(arrayScope, arrayScope, index)

  return {
    ...uiSchema,
    scope: scope,
    scopeRef: scopeRef,
    elements: uiSchema.elements
      ? uiSchema.elements.map((el) => convertUiSchemaArray(el, arrayScope, index, scope || actParentScope))
      : undefined,
    exclude: uiSchema.exclude ? uiSchema.exclude.map((ex) => scopeAddRepeat(ex, arrayScope, index)) : undefined,
    allRules: uiSchema.allRules ? modifRules(scope || actParentScope, uiSchema.allRules) : undefined,
  }
}
